<template>
  <div class="newtoolbar">
    <CurvedBottomNavigation
        foreground-color='#1fa29d'
        badge-color='#FBC02D'
        background-color='#FFFFFF'
        icon-color='#0000008A'
        :options="options" v-model="selected">
      <template #icon="{ props }">
        <i :class="props.icon"></i>
      </template>
      <template #title="{ props }">
        <b>{{ props.title }}</b>
      </template>

    </CurvedBottomNavigation>

  </div>
</template>
<script>
import { CurvedBottomNavigation } from "bottom-navigation-vue";
import "bottom-navigation-vue/dist/style.css";

export default {
  components: { CurvedBottomNavigation },
  name: 'footer-app',
  data: () => ({
    selected: 1,
    options: [

      {
        id: 1,
        icon: "fa-solid fa-badge-percent",
        title: "سفارشات ",
        path: { name: "orders" },
      },{
        id: 3,
        icon: "fas fa-cart-shopping",
        title: "سبد خرید",
        badge: 5 ,
        path: { name: "cart" },
      },
      {
        id: 2,
        icon: "fas fa-home",
        title: "صفحه اصلی",
        path: { name: "home" },
      },

      {
        id: 5,
        icon: "fas fa-heart",
        title: "نشان شده ها",
        path: { name: "heart" },
      },
      {
        id: 4,
        icon: "fas fa-user",
        title: "حساب کاربری",
        path: { name: "profile" },
      },
    ],
  }),
  methods: {
    op(){
      this.options[1].badge = this.badgeCart;
    }
  },
  updated() {
    this.op();
  },
  mounted () {
    this.selectedItems;
    this.op();
  },
  computed: {
    selectedItems(){
      this.selected = this.selectedItem;
    },
    badgeCart(){
      console.log(this.options);
      this.options[1].badge = this.badgeCart;
    }
  },
  props: [
    "selectedItem",
    "badgeCart"
  ],
}
</script>
<style scoped>
.newtoolbar{
  width: 100%;
  height: 60px;
  background: #1fa29d;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000000;
}
.btn-container i{
  font-size: 1.5rem !important;
}
</style>